export function protectSignedFileLinks(document: Document): () => void {
  const preserveSignature = (event: Event) => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (!new URLSearchParams(anchor.search).has('X-Amz-Signature')) return;

    // Google's linker decorates anchors on document mousedown/keyup. Signed
    // URLs must reach native navigation unchanged; click stays untouched.
    event.stopPropagation();
  };
  document.addEventListener('mousedown', preserveSignature, true);
  document.addEventListener('keyup', preserveSignature, true);
  return () => {
    document.removeEventListener('mousedown', preserveSignature, true);
    document.removeEventListener('keyup', preserveSignature, true);
  };
}
